import React, { Component } from 'react'
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
} from 'reactstrap'
import { database } from '../config'

import './slider.css'

export default class Slider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            items: []
        }
        this.next = this.next.bind(this)
        this.previous = this.previous.bind(this)
        this.goToIndex = this.goToIndex.bind(this)
        this.onExiting = this.onExiting.bind(this)
        this.onExited = this.onExited.bind(this)
    }

    next() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === this.state.items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? this.state.items.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({ activeIndex: newIndex });
    }

    onExiting() {
        this.animating = true;
    }

    onExited() {
        this.animating = false;
    }


    componentWillMount() {
        let _this = this
        database.collection('imgEmpresa')
            .onSnapshot(querySnapshot => {
                _this.setState({
                    items: querySnapshot.docs
                })
            })
    }


    render() {
        const { activeIndex, items } = this.state;

        const slides = items.map((item) => {
            //item = item.data()
            return (
                <CarouselItem
                    onExiting={this.onExiting}
                    onExited={this.onExited}
                    key={item.id}
                >
                    <img src={item.data().src} alt={item.data().altText} />
                    <CarouselCaption captionText={item.data().caption} captionHeader={item.data().caption} />
                </CarouselItem>
            )
        })

        return (
            <Carousel
                    activeIndex={activeIndex}
                    next={this.next}
                    previous={this.previous}
                    ride={'carousel'}
                    autoplay={true}
                >
                    <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
                    {slides}
                    <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
                    <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
                </Carousel>

        )

    }

}